export default __webpack_public_path__ + "a03d28d86d858234534306b63a6de3b2.jpg";